import GetLotteryTicketResponse, {
    DiscountSource,
    DiscountType,
    PromoCode,
    PromoCodeCampaign,
    TicketStatus,
} from '../CRM/Responses/LotteryTicketResponse';

import Money from '../Types/Money';

import Model from './Model';

import { LotteryType } from 'Api/CRM/Responses/LotteryResponse';
import { DrawNumbers } from 'components/play/Types/Types';

export default class LotteryTicket extends Model {
    readonly id: number;
    readonly official_uuid: string | null;
    readonly user_id: number;
    readonly lottery_multi_draw_ticket_id: number | null;
    readonly ticket_type: string;
    readonly lottery_id: number;
    readonly lottery_rule_id: number | null;
    readonly lottery_rule_tier_multiplier_id: number | null;
    readonly game_type: string | null;
    readonly game_type_slug: string | null;
    readonly multiplier: string | null;
    readonly lottery_draw_id: number | null;
    readonly reseller_customer_id: number | null;
    readonly token: string | null;
    readonly draw_date: string | null;
    readonly system_sell_amount_net: number;
    readonly system_sell_amount_gross: number;
    readonly system_sell_amount_currency_code: string | null;
    readonly sale_tax_percent: number;
    readonly system_sale_tax_fixed: number;
    readonly system_sale_tax_sum: number;
    readonly reseller_revenue: number;
    readonly status: TicketStatus;
    readonly paid_out: boolean;
    readonly paid_out_reseller_id: number | null;
    readonly prize_tax_percent: number | null;
    readonly is_synced: boolean;
    readonly ip: string | null;
    readonly ip_country_code: string | null;
    readonly created_at: string | null;
    readonly updated_at: string | null;
    readonly promo_code_campaign_id: number | null;
    readonly promo_code_id: number | null;
    readonly discount_source: DiscountSource | null;
    readonly discount_type: DiscountType | null;
    readonly system_discount_amount: number | null;
    readonly system_ticket_value: number;

    // additional props
    readonly promo_code_campaign: PromoCodeCampaign | null;
    readonly promo_code: PromoCode | null;
    readonly email: string | null;
    readonly phone: string | null;
    readonly name: string | null;
    readonly surname: string | null;
    readonly print_count: number;
    readonly type: string;
    readonly lottery_timezone: string;
    readonly lottery_slug: string;
    readonly lottery_name: string;
    readonly lottery_type: LotteryType;
    readonly reseller_customer_email: string | null;
    readonly draw_numbers: DrawNumbers;
    readonly can_be_paid_out: boolean;
    readonly prizeNet: Money | null;
    readonly prizeGross: Money | null;
    readonly prizeTaxFixed: Money | null;
    readonly prizeTaxSum: Money | null;
    readonly systemPrizeNet: Money | null;
    readonly systemPrizeGross: Money | null;
    readonly systemPrizeTaxFixed: Money | null;
    readonly systemPrizeTaxSum: Money | null;
    readonly ticket_markup: number | null;

    constructor(ticket: Partial<GetLotteryTicketResponse>) {
        super();
        this.assignDataToProps(ticket, [
            'id',
            'official_uuid',
            'user_id',
            'lottery_multi_draw_ticket_id',
            'ticket_type',
            'lottery_id',
            'lottery_rule_id',
            'lottery_rule_tier_multiplier_id',
            'game_type',
            'game_type_slug',
            'multiplier',
            'lottery_draw_id',
            'reseller_customer_id',
            'token',
            'draw_date',
            'system_sell_amount_net',
            'system_sell_amount_gross',
            'system_sell_amount_currency_code',
            'sale_tax_percent',
            'system_sale_tax_fixed',
            'system_sale_tax_sum',
            'reseller_revenue',
            'status',
            'paid_out',
            'paid_out_reseller_id',
            'prize_tax_percent',
            'is_synced',
            'ip',
            'ip_country_code',
            'created_at',
            'updated_at',
            'promo_code_campaign_id',
            'promo_code_id',
            'discount_source',
            'discount_type',
            'system_discount_amount',
            'system_ticket_value',
            'promo_code_campaign',
            'promo_code',
            'email',
            'phone',
            'name',
            'surname',
            'print_count',
            'type',
            'lottery_timezone',
            'lottery_slug',
            'lottery_name',
            'lottery_type',
            'reseller_customer_email',
            'draw_numbers',
            'can_be_paid_out',
            'prizeNet',
            'prizeGross',
            'prizeTaxFixed',
            'prizeTaxSum',
            'systemPrizeNet',
            'systemPrizeGross',
            'systemPrizeTaxFixed',
            'systemPrizeTaxSum',
            'ticket_markup',
        ]);
    }
}
